module.exports = __webpack_public_path__ + "static/collectorcans-del-blue-artwork-b49af5d6b797cefeea68492d14ee848a.png";